import type {OrderReplacementCardRequest} from '../../../types/order-replacement-card-request'

const normalizeOrderReplacementCardRequest = function (input: OrderReplacementCardRequest): Object {
  return {
    orderReplacementCardItems: input.orderReplacementCardItems.map(cardReplacementItem => {
      return {
        cardId: cardReplacementItem.cardId,
        ascription: cardReplacementItem.ascription,
        ascription1: cardReplacementItem.ascription1,
        ascription2: cardReplacementItem.ascription2,
        cardTheme: cardReplacementItem.cardTheme,
        cardHolderDetails: cardReplacementItem.cardHolderDetails
      }
    })
  }
}

export {
  normalizeOrderReplacementCardRequest
}



// WEBPACK FOOTER //
// ./src/services/b2b/normalizer/order-replacement-card-request-normalizer.js